export const subscriptionKeys = {
  all: ['subscriptions'] as const,
  plans: () => [...subscriptionKeys.all, 'plans'] as const,
  activePlans: () => [...subscriptionKeys.plans(), 'active'] as const,
  plan: (id: string) => [...subscriptionKeys.plans(), id] as const,
  providerSubscriptions: () => [...subscriptionKeys.all, 'provider'] as const,
  providerSubscription: (providerId: string) =>
    [...subscriptionKeys.providerSubscriptions(), providerId] as const,
  activeProviderSubscription: (providerId: string) =>
    [...subscriptionKeys.providerSubscription(providerId), 'active'] as const,
  activePromotion: () => [...subscriptionKeys.all, 'promotion', 'active'] as const,
  founderSpots: () => [...subscriptionKeys.all, 'founder-spots'] as const,
};
